import { SettingsService } from '../settings/settings.service';
import { InitializerEffects } from '../../state-management/initializer/initializer.effects';
import * as mixpanel from 'mixpanel-browser';
import { Injectable } from '@angular/core';
import { first, map } from 'rxjs/operators';


const mixpanelFalbackMock = {
    init: (...a: any) => ({}),
    track: (...a: any) => ({}),
    identify: (...a: any) => ({}),
    alias: (...a: any) => ({}),
    people: {
        set: (...a: any) => ({}),
    },
};

@Injectable()
export class TrackingService {
    private mixpanelInitialized: boolean = false;
    constructor(
        private settings: SettingsService,
        private initialization: InitializerEffects
    ) {
        // Initialize mixpanel library
        this.initializeMixpanel();
    }

    //initialize mixpanel
    private initializeMixpanel() {
        this.initialization.settingsLoaded$
            .pipe(
                first(),
                map(() =>
                    this.settings.getConfigurationKeyValue("mixpanelApiKey")
                ),
                first((apiKey) => !!apiKey)
            )
            .subscribe((apiKey) => {
                if (
                    typeof mixpanel !== "undefined" &&
                    typeof mixpanel.init === "function"
                ) {
                    console.log("Mixpanel initialized");
                    this.mixpanelInitialized = true;
                    return mixpanel.init(apiKey);
                }
            });
    }

    /* Track mixpanel
     * @param type nome do track que vai ser enviado para o mixpanel
     * @param value valores para atribuir a um track
     */
    public track(type: string, value: object) {
        if (!this.mixpanelInitialized) return;
        mixpanel.track(type, value);
    }

    /* Identify mixpanel
     * @param clientId id de identificação
     */
    public identify(clientId: string) {
        if (!this.mixpanelInitialized) return;
        mixpanel.identify(clientId);
    }

    /* People Set mixpanel
     * @param value valores para atribuir a um usuário
     */
    public peopleSet(value: mixpanel.Dict) {
        if (!this.mixpanelInitialized) return;
        mixpanel.people.set(value);
    }

    /* People Set mixpanel
     * @param value valores para atribuir a um usuário
     */
    public alias(clientId: string) {
        if (!this.mixpanelInitialized) return;
        mixpanel.alias(clientId);
    }
}
